import React from "react";

import * as Styled from "./styles";
import { ISteps } from "shared/types";

import { GiHealthNormal } from "react-icons/gi";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaUserDoctor } from "react-icons/fa6";
import { Divider } from "@mui/material";
import { RiHealthBookLine } from "react-icons/ri";
import { useMetrus } from "shared/providers";

interface IProps {
  data: ISteps;
  active: boolean;
  onClick?: () => void;
}

const BoxStep: React.FC<IProps> = ({ data, active, onClick }) => {
  const { planShow, specialistId, regionName, cityId, step } = useMetrus();
  return (
    <>
      <Styled.Container active={active} onClick={onClick}>
        {data.icon === 1 && <GiHealthNormal size={31} />}
        {data.icon === 2 && <FaMapLocationDot size={31} />}
        {data.icon === 3 && <FaUserDoctor size={31} />}
        {data.icon === 4 && <RiHealthBookLine size={31} />}
        <Styled.TitleSubtitle>
          <h3>{data.title}</h3>
          <p>{data.subtitle}</p>

          <Styled.BoxInfoSpecialist>
            {data.icon === 1 ? planShow : ""}
          </Styled.BoxInfoSpecialist>
          <Styled.BoxInfoSpecialist>
            {data.icon === 2
              ? `${cityId} ${regionName ? `- ${regionName}` : ""}`
              : ""}
          </Styled.BoxInfoSpecialist>
          <Styled.BoxInfoSpecialist>
            {data.icon === 3 ? specialistId : ""}
          </Styled.BoxInfoSpecialist>
          <Styled.BoxInfoSpecialist>
            {data.icon === 4 && step > 3 ? "Consulte o resultado" : ""}
          </Styled.BoxInfoSpecialist>
        </Styled.TitleSubtitle>
      </Styled.Container>
      {data.icon !== 4 && (
        <Divider sx={{ height: "50px" }} orientation="vertical" />
      )}
    </>
  );
};

export { BoxStep };
